//Generates SVG given a list of nodes and edges (used by AutoSVG)

import React, {useState, useEffect} from "react";


function GenSVG({offset, nodes, edges}) {
  const [svgNodes, setSVGNodes] = useState([]);
  const [svgEdges, setSVGEdges] = useState([]);
  const [svgDims, setSVGDims] = useState({width:0, height:0});

  const yoffset = 22; //for edges relative to nodes
  const xoffset = 22; //for edges relative to nodes


  //Sets node positions on svg relative to svg size.
  function setNodePositions() {
    let nodepos = nodes.map((node) => {
    if(node.nodeType == 'shape'){
        return {id:node.id, type:node.nodeType, svg: node.svg, scale: 0.3, x: node.x, y: node.y};
    } else if (node.nodeType == 'text'){
        return {id:node.id, type:node.nodeType, content:node.label, scale: 0.3, x: node.x, y: node.y};
    }
    });      
    
    let xvals = nodepos.map(obj => obj.x);
    let yvals = nodepos.map(obj => obj.y);

    if (nodepos.length > 1) {
      let minX = Math.min(...xvals);
      let maxX = Math.max(...xvals);
      let minY = Math.min(...yvals);
      let maxY = Math.max(...yvals);

      nodepos = nodepos.map((node) => {
          return {...node, x: node.x - minX, y: node.y - minY};
      });
      
      let width = maxX - minX;
      let height = maxY - minY;

      setSVGDims({width:width+10, height:height+30});
      } else {
      setSVGDims({width:10, height:10});
      }
    
    setSVGNodes(nodepos);

    let edgepos = edges.map((edge) => {
        let from = nodepos.find(node => node.id === edge.from);
        let to = nodepos.find(node => node.id === edge.to);
        if(from !== undefined && to !== undefined){
          return {from:{x:from.x, y:from.y}, to:{x:to.x, y:to.y}, label:edge.label};
        } else {
          return {from:{x:0, y:0}, to:{x:0, y:0}, label:''}
        }
      });
      setSVGEdges(edgepos);
  }

  //Sets label position for edges.
  function calculateLabelPos(xfrom, xto, yfrom, yto) {
    let angle, xpos, ypos;
    angle = Math.atan2(yto-yfrom, xto - xfrom)*(180/Math.PI);
    if(angle > 90 || angle < -90){angle += 180};
    xpos = (xfrom+xto)/2 + xoffset;
    ypos = (yfrom+yto)/2 + yoffset;
    
    // if want text unrotated.
    //return `rotate(${angle}, ${xpos}, ${ypos}), translate(0, -15), rotate(${-angle}, ${xpos}, ${ypos})`;
    return `rotate(${angle}, ${xpos}, ${ypos}), translate(0, -15), rotate(${0}, ${xpos}, ${ypos})`;
  }

  //Splits multi-line text
  function splitText(node)
  {
    const text = node.content;
    let content = [];
    const words = text.split(' ');
    const letter_limit = 25;
    const dY_val= '1.2em';
    let longestContent = 0;
    let spanText = "";
    for (let i = 0; i < words.length; i++)
    {
      spanText += words[i] + (i < words.length-1 ? " " : "");
      if (spanText.length > letter_limit)
      {
        if(longestContent < spanText.length)
        {
          longestContent = spanText.length;
        }
        content.push(
          <tspan x={node.x} dy={dY_val}>{spanText}</tspan>
        )
        
        spanText = "";
      }
    }

    if(longestContent < spanText.length)
    {
      longestContent = spanText.length;
    }
    
    let txtWidth = longestContent * 6;
    if (spanText !== '') {
      content.push(
        <tspan x={node.x} dy={dY_val}>{spanText}</tspan>
      )
    }

    let txtHeight = content.length * 17;

    const rectBorder = 15;

    return (
      <g transform={`translate(${txtWidth/2}, ${txtHeight/2})`}>
        <rect x={node.x - (txtWidth/2) - rectBorder/2} y={node.y - (txtHeight/2) - rectBorder/2} 
        width={txtWidth + rectBorder} height={txtHeight + rectBorder + 2} style={{fill:'white'}} />
        <text x={node.x - (txtWidth/2)} y={node.y - (txtHeight/2)} 
            scale={node.scale} 
            style={{ fontSize: '20' , fontWeight: 'bold'}}
            textAnchor="middle">
        {content.map((element) => element)}
        </text>
      </g>
    )
  }
  
  useEffect(() => {
    setNodePositions();
  }, [offset, nodes, edges]);

  return (
    <svg xmlns="http://www.w3.org/2000/svg" 
      viewBox={`0 0 ${svgDims.width + 2 * offset.x} ${svgDims.height + 2 * offset.y}`} 
      style={{width: '100%', height:'100%'}}>
      
      <g transform={`translate(${offset.x},${offset.y})`}>
        {
          //Draw the edges
          //edge dashes should be 10 5
          svgEdges.length > 0 && svgEdges.map((edge, index) => {
            return (<g>
              <line x1={edge.from.x+xoffset} y1={edge.from.y+yoffset} x2={edge.to.x+xoffset} y2={edge.to.y+yoffset} 
                    stroke="black" stroke-width="5" stroke-dasharray={edge.label && edge.label[0] == 'β' ? "" : ""}/> 
              <text x={(edge.from.x+xoffset + edge.to.x+xoffset)/2} y={(edge.from.y+yoffset + edge.to.y+yoffset)/2} 
                    transform={calculateLabelPos(edge.from.x, edge.to.x, edge.from.y, edge.to.y)} 
                    style={{ fontSize: '20' }}
                    textAnchor="middle" class="heavy" >{edge.label}</text>
            </g>)
          })
        }
        {
          //Draw the shape nodes
          svgNodes.length > 0 && 
          svgNodes
          .filter((node) => node.type === 'shape')
          .map((node, index) => (
            <g 
              
              transform={`translate(${node.x}, ${node.y}) scale(${node.scale}) `}
              dangerouslySetInnerHTML={{ __html: node.svg }} 
            />
          ))
        }
        {
          //Draw the text nodes
          svgNodes.length > 0 && 
          svgNodes
          .filter((node) => node.type === 'text')
          .map((node, index) => (
            splitText(node)
          ))
        }
        </g>
      </svg>
  );
}

export default GenSVG;